import { useLocation } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { appRoutes } from 'utils/routing/routes';

type PublicLayoutSettings = {
  headingText: string;
  subheadingText: string;
  isLoginScreen: boolean;
  flexLastChildBottom?: boolean;
  flexFillScreenOnMobile?: boolean;
};

export const usePublicLayoutSettings = (): PublicLayoutSettings => {
  const { t } = useTranslation();
  const location = useLocation();

  switch (location.pathname) {
    case appRoutes.logOut:
      return {
        headingText: t('Layout.LogOut.Heading'),
        subheadingText: '',
        isLoginScreen: false,
      };
    case appRoutes.loggedOut:
      return {
        headingText: t('Layout.LogOut.Heading'),
        subheadingText: '',
        isLoginScreen: false,
      };
    case appRoutes.register:
      return {
        headingText: t('Layout.Register.Heading'),
        subheadingText: t('Layout.Register.SubHeading'),
        isLoginScreen: false,
        flexLastChildBottom: true,
        flexFillScreenOnMobile: true,
      };
    case appRoutes.forgottenPassword:
      return {
        headingText: t('Layout.PassRecovery.Heading'),
        subheadingText: t('Layout.PassRecovery.SubHeading'),
        isLoginScreen: false,
        flexLastChildBottom: true,
        flexFillScreenOnMobile: true,
      };
    case appRoutes.error:
      return {
        headingText: t('Layout.Error.Heading'),
        subheadingText: t('Layout.Error.Subheading'),
        isLoginScreen: false,
      };
    default:
      return {
        headingText: t('Layout.Heading'),
        subheadingText: t('Layout.Subheading'),
        isLoginScreen: true,
        flexLastChildBottom: true,
      };
  }
};
